import * as React from 'react';
import OurLogoContent from '../components/AboutUs/OurLogo';
import MissionContent from '../components/AboutUs/Mission';

export class Mission extends React.Component<any, any> {
    constructor(props, context) {
        super(props, context);
    }
    render() {
        return (<div id="SectionContainer" >
            <section className="full-page double-rings-bg base3-bg mission" style={{backgroundColor: "#f5f5f5"}}>
                <div>
                    <div className="container" style={{paddingBottom: "380px", paddingTop: "200px"}}>
                        <h1>Our Mission</h1>
                        <MissionContent />
                    </div>
                </div>
            </section>
        </div>
        );
    }
}


/**
 * Turn this and mission into a content data driven component
 */
export class AboutLogo extends React.Component<any, any> {
    constructor(props, context) {
        super(props, context);
    }
    render() {
        return (
                <div id="SectionContainer" >
                    <section className='content'>
                        <div  className="container page-content">
                            <h1>Our logo</h1>
                            <div className="row">
                            <div className="col-12 col-md-6">
                                    <OurLogoContent />
                                </div>
                                <div className="col-12 col-md-6">
                                    <img className="mb-2 mt-2" src={require("../assets/img/2.6_Our-Logo_artwork-image.png")} width="100%"/>
                                    <div className="small text-muted">
                                        Original art by Max Mansell. Photo: David Hansen
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/Mission.tsx